export const UpdateDriver_ValidateFields = async ({ context, session }) => {
    // console.log(context, session)
    if (Object.keys(session)?.length === 0) {
        return;
    }
    // Run validations concurrently
    var validationPromises = [
        ValidateEditDriverOption(session),
        ValidateEffDate(session),
        ValidateOwnInsurance(session),
        ValidateCurrentLicenseStatus(session),
        ValidateDateOccurrence(session),
        ValidateVehiclesAtNewAddress(session),
        ValidateNewAddressVehicles(session),
    ];

    const validationResults = await Promise.all(validationPromises);
    var invalidResults = validationResults.filter(result => result.valid === false);

    return invalidResults;
}

const Validate = (value) => {
    if (value == undefined) { // No input on the screen
        return false
    } else if (value == "" || value == "Select from the following..." || value == []) { // Input on screen value not filled
        return true
    } else { // Input is filled
        return false
    }
}

const ValidateEffDate = async (session) => {
    if(Validate(session?.requestedEffDate)){
        return { title: "Oops!", message: 'Please enter a valid Requested Effective Date.', valid: false };
    }
    return { valid: true }
}

const ValidateEditDriverOption = (session) => {
    if (Validate(session?.editType)) {
        return { title: "Oops!", message: 'Please select what you would like to edit about this driver.', valid: false };
    }
    return { valid: true }
}
const ValidateOwnInsurance = (session) => {
    if (Validate(session?.driverInfo?.ownInsurance)) {
        return { title: "Oops!", message: 'Please determine if this driver obtained their own car insurance.', valid: false };
    }
    return { valid: true }
}
const ValidateCurrentLicenseStatus = (session) => {
    if (Validate(session?.driverInfo?.licenseStatus)) {
        return { title: "Oops!", message: 'Please provide the current status of this driver\'s license.', valid: false };
    }
    return { valid: true }
}
const ValidateDateOccurrence = (session) => {
    if (Validate(session?.driverInfo?.dateOccurred)) {
        return { title: "Oops!", message: 'Please provide the date of this occurrence.', valid: false };
    }
    return { valid: true }
}
const ValidateVehiclesAtNewAddress = (session) => {
    if (Validate(session?.vehicleInfo?.takeVehiclesToNewAddress)) {
        return { title: "Oops!", message: 'Please determine if this driver is taking any policy vehicles with them to their new address.', valid: false };
    }
    return { valid: true }
}
const ValidateNewAddressVehicles = (session) => {
    if (Validate(session?.vehicleInfo?.vehiclesAtNewAddress)) {
        return { title: "Oops!", message: 'Please check which vehicles will be taken to the new address.', valid: false };
    }
    return { valid: true }
}